class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.closeTimer = null;
    this.renderSequence = 0;
  }

  open() {
    window.clearTimeout(this.closeTimer);
    this.notification.classList.remove('active');
    void this.notification.offsetWidth;
    this.notification.classList.add('animate', 'active');
    this.closeTimer = window.setTimeout(() => this.close(), 6000);
  }

  close() {
    this.notification.classList.remove('active');
    window.clearTimeout(this.closeTimer);
  }

  async renderContents(parsedState) {
    this.renderSequence += 1;
    const currentSequence = this.renderSequence;
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target || !parsedState.sections[section.id]) return;
      target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const productName = parsedState.product_title || parsedState.title;
    const message = this.querySelector('[data-cart-toast-message]');
    if (message) message.textContent = productName ? `${productName} added` : 'Item added to your cart';

    try {
      const response = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      if (currentSequence !== this.renderSequence) return;

      const subtotal = this.querySelector('[data-cart-toast-subtotal]');
      const currency = window.Shopify?.currency?.active || 'PHP';
      const formattedTotal = new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency,
      }).format(cart.total_price / 100);

      if (subtotal) subtotal.textContent = `Cart subtotal: ${formattedTotal}`;

      const minimumRemaining = Math.max(0, 100000 - cart.total_price);
      const shippingRemaining = Math.max(0, 300000 - cart.total_price);
      const formatAmount = (amount) =>
        new Intl.NumberFormat('en-PH', { style: 'currency', currency }).format(amount / 100);

      const minimumMessage = this.querySelector('[data-cart-toast-minimum]');
      if (minimumMessage) {
        minimumMessage.textContent = minimumRemaining > 0
          ? `${formatAmount(minimumRemaining)} left to reach the ₱1,000 minimum`
          : '₱1,000 minimum reached';
      }

      const shippingMessage = this.querySelector('[data-cart-toast-shipping]');
      if (shippingMessage) {
        shippingMessage.textContent = shippingRemaining > 0
          ? `${formatAmount(shippingRemaining)} left for free shipping`
          : 'Free shipping unlocked';
      }

      const cartLink = document.getElementById('cart-notification-button');
      if (cartLink) cartLink.textContent = `See Cart (${cart.item_count})`;
    } catch (error) {
      const subtotal = this.querySelector('[data-cart-toast-subtotal]');
      if (subtotal) subtotal.textContent = '';
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [{ id: 'cart-icon-bubble' }];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return source ? source.innerHTML : '';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
